import * as http from "./base";

const prefix = "/tags-";

export async function fetchTagsList({ page, sort, search, page_size = 100, queryString }) {
  const qs = http.prepareQueryString({
    page,
    sort,
    search,
    page_size,
    queryString
  });
  return await http.get(`${prefix}list/?${qs}`);
}

export async function createTag(data) {
  return await http.post(`${prefix}create`, data);
}

export async function fetchTagById(id) {
  return await http.get(`${prefix}retrieve/${id}`);
}

export async function deleteTag(id) {
  return await http.del(`${prefix}delete/${id}`);
}

export async function deleteTags(idsStr) {
  return await http.del(`${prefix}delete/?ids=${idsStr}`)
}
